/** SUNTRONIX ONE — Address Verified badge (§7-9, §77). */
import { CheckCircle2, AlertTriangle, ShieldAlert, Clock } from "lucide-react";

const STATE_MAP = {
  EMPLOYEE_VERIFIED:              { tone: "ok",    label: "Verified · employee",     Icon: CheckCircle2 },
  CUSTOMER_VERIFIED:              { tone: "ok",    label: "Verified · customer",     Icon: CheckCircle2 },
  SUNTRONIX_VERIFIED:             { tone: "ok",    label: "Verified · Suntronix",    Icon: CheckCircle2 },
  COURIER_VALIDATED:              { tone: "ok",    label: "Courier validated",       Icon: CheckCircle2 },
  EMPLOYEE_CONFIRMED:             { tone: "ok",    label: "Verified · employee",     Icon: CheckCircle2 },
  CUSTOMER_CONFIRMED:             { tone: "ok",    label: "Verified · customer",     Icon: CheckCircle2 },
  VERIFICATION_PENDING:           { tone: "warn",  label: "Verification pending",    Icon: Clock },
  CHANGED_REVERIFICATION_REQUIRED:{ tone: "warn",  label: "Changed · re-verify",     Icon: ShieldAlert },
  NOT_VERIFIED:                   { tone: "warn",  label: "Not verified",            Icon: AlertTriangle },
  UNVERIFIED:                     { tone: "warn",  label: "Not verified",            Icon: AlertTriangle },
};

export default function AddressVerifiedBadge({ status, verifiedBy, verifiedAt, testId, size = "md" }) {
  const s = STATE_MAP[(status || "").toUpperCase()] || STATE_MAP.NOT_VERIFIED;
  const cls = s.tone === "ok"
    ? "bg-emerald-50 text-emerald-800 border-emerald-200"
    : "bg-amber-50 text-amber-900 border-amber-200";
  const px = size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-1 text-[12px]";
  return (
    <span data-testid={testId || "address-verified-badge"}
      className={`inline-flex items-center gap-1 rounded border ${cls} ${px}`}>
      <s.Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} strokeWidth={1.8} />
      <span className="font-medium">{s.label}</span>
      {s.tone === "ok" && verifiedBy && (
        <span className="opacity-70">· {verifiedBy}{verifiedAt ? ` · ${new Date(verifiedAt).toLocaleDateString()}` : ""}</span>
      )}
    </span>
  );
}
